export const isSmall = () => window.innerWidth <= 900;
